import React, {useState} from 'react';
import {callAPI, useMetricSystem} from "../../lib/common";
import {cmToInches, formatCurrency} from "../../utils";
import {useTranslation} from "react-i18next";

export const PriceListContext = React.createContext();


// We should export all functions like this?
export const isWhiteBorderProduct = (product) => {
  return product.producttype == 0 && product.name.match(/(white border|hvit kant|vita kanter|valkoiset reunat|Hvítur kantur)/i)
}

export default ({children}) => {
  const [state, setState] = useState(window.NTLF_PRICE_LIST);
  const [t] = useTranslation();

  const getProductByUuid = (uuid) => {
    return state.products.find(product => product.uuid == uuid)
  }

  const getPrintFormats = () => {
    console.log('Products', state.products)
    const printFormats = state.products.filter(product => {
      console.log(product.producttype, product.name);
      return product.producttype == 0;
      // Elitefoto used to not include white border:
      //return product.producttype == 0 && !product.name.match(/(hvit kant)/i);
    }).sort ( (a, b) => {
      return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
    })
    console.log('Print formats', printFormats);
    return printFormats;
  }


  const getFormatSizeName = (product) => {
    const re = product.name.match(/^(\d+x\d+)\b/i);
    if (re) {
      return re[1];
    }
    return product.name;
  }

  const isSameFormat = (product1, product2) => {
    const name = getFormatSizeName(product1);
    const reg = new RegExp("^"+name+"\\b");
    return product2.name.match(reg);
  }

  const getWhiteBorderAlternativeProduct = (product) => {
    const whiteBorderProduct  =  state.products.find(p => {
      return isWhiteBorderProduct(p) && isSameFormat(p, product);
    })
    console.log('White border product', whiteBorderProduct);
    return whiteBorderProduct;
  }

  const getNonWhiteBorderAlternativeProduct = (product) => {
    const whiteBorderProduct  =  state.products.find(p => {
      return !isWhiteBorderProduct(p) && isSameFormat(p, product);
    })
    console.log('Non white border product', whiteBorderProduct);
    return whiteBorderProduct;
  }

  const getSmallestPaperSize = () => {
    return state.products.reduce( (smallestSize, product) => {
      if (product.producttype != 0) {
        return smallestSize;
      }
      const match = product.name.match(/(\d+)x(\d+)/);
      if (match) {
        const width = parseInt(match[1]);
        const height = parseInt(match[2]);
        console.log('Found match in format', width, height)
        if (width * height < smallestSize.width * smallestSize.height) {
          return {
            width,
            height
          }
        } else {
          console.log('Existing format is smaller', smallestSize)
        }
        return smallestSize;
      }
      return smallestSize;
    }, {width: Number.MAX_SAFE_INTEGER, height: Number.MAX_SAFE_INTEGER});
  }

  const getLargestPaperSize = () => {
    return state.products.reduce( (largestSize, product) => {
      if (product.producttype != 0) {
        return largestSize;
      }
      const match = product.name.match(/(\d+)x(\d+)/);
      if (match) {
        const width = parseInt(match[1]);
        const height = parseInt(match[2]);
        if (width * height > largestSize.width * largestSize.height) {
          return {
            width,
            height
          }
        }
        return largestSize;
      }
      return largestSize;
    }, {width: 0, height: 0});
  }

  const productHasCampaign = (product, category) => {
    if (product.campaignrequirement && category != product.campaignrequirement) {
      return false;
    }

    return (product.productprices.filter(pp => pp.campaignprice > 0).length > 0);
  }

  const getPriceAsString = (product, categories) => {
    const pp = product.productprices;

    let hasCampaign = false;
    if (categories) {
      for (const category of categories) {
        if (productHasCampaign(product, category)) {
          hasCampaign = true;
          break;
        }
      }
    }

    if (hasCampaign) {
      if (pp.length == 1) {
        return formatCurrency(pp[0].campaignprice);
      }
      return t("Campaign prices from %s", {postProcess: 'sprintf', sprintf: [formatCurrency((pp[pp.length - 1].campaignprice))]})
    }
    else {
      if (pp.length == 1) {
        return formatCurrency(pp[0].price);
      }
      return t("Prices from %s", {postProcess: 'sprintf', sprintf: [formatCurrency((pp[pp.length - 1].price))]})
    }
  }

  const getPricePerUnit = (product, quantity, hasCampaignPrice) => {
    let ppu = -1.0;
    for (const productPrice of product.productprices) {
      if (quantity >= parseInt(productPrice.quantity)) {
        if (hasCampaignPrice) {
          ppu = productPrice.campaignprice;
        }
        else {
          ppu = productPrice.price;
        }
      }
    }
    return ppu;
  }

  const calculateLinePrice  = (productUuid, quantity, subProductUuid, hasCampaignPrice) => {
    const product = getProductByUuid(productUuid);
    if (!product) {
      return -1;
    }

    let priceScheme = 1;
    if (product.productprices[0].type == 0) {
      priceScheme = 0;
    }

    let ppu = getPricePerUnit(product, quantity, hasCampaignPrice);

    let subProductPrice = 0;
    if (subProductUuid) {
      subProductPrice = product.subproducts.find(sp => sp.uuid == subProductUuid).extraprice;
    }

    // FIXME: Sub products and campaign prices?
    if (priceScheme == 0) {
      return (ppu * quantity) + (subProductPrice*quantity);
    }

    console.log('Using unit pricing');
    // Unit pricing:
    let totalPrice = 0;
    for (let i = 0; i<quantity; i++) {
      ppu = getPricePerUnit(product, i+1, null, hasCampaignPrice);
      totalPrice += (ppu + subProductPrice);
    }
    return totalPrice;
  }

  console.log('The state', state);

  return <PriceListContext.Provider
    value={{state, getProductByUuid, getPrintFormats, calculateLinePrice,
      getWhiteBorderAlternativeProduct, isSameFormat, isWhiteBorderProduct,
      getNonWhiteBorderAlternativeProduct, getFormatSizeName, getSmallestPaperSize, getLargestPaperSize,
      getPriceAsString, getPricePerUnit, productHasCampaign
    }}>
    {children}
  </PriceListContext.Provider>
}


const usePriceList = () => {
  return React.useContext(PriceListContext);
}

export {
  usePriceList
}